import $ from 'jquery';

$(document).ready(function () {
  $('.accordion-header').click(function () {
    const parentItem = $(this).closest('.accordion-item');
    const content = parentItem.find('.accordion-content');

    if (parentItem.hasClass('active')) {
      content.slideUp(300);
      parentItem.removeClass('active');
    } else {
      $('.accordion-item.active .accordion-content').slideUp(300);
      $('.accordion-item').removeClass('active');
      content.slideDown(300);
      parentItem.addClass('active');
    }
  });
});
